@let isUserAuthenticatedAndAuthDone = !isAuthLoading && authService.isAuthenticated() && !isGetEmployeeDetailsLoading();
<mat-sidenav-container>
  <mat-sidenav class="sidenav" [opened]="sidebarService.isOpen()" (closed)="sidebarService.close()" autoFocus="false" position="end">
    @if (isUserAuthenticatedAndAuthDone) {
      <app-mobile-nav></app-mobile-nav>
    }
  </mat-sidenav>
  @if (isUserAuthenticatedAndAuthDone) {
    <app-header />
  } @else {
    @if (!isRouterPathUnauthorizedOrMaintenance()) {
      <app-header-placeholder />
      <app-loading [loadingMode]="LoadingMode.FULLSCREEN" />
    }
  }
  @if (!isAuthLoading) {
    <div class="content-wrapper" role="main">
      @if (isRouterPathUnauthorizedOrMaintenance()) {
        <app-header-placeholder></app-header-placeholder>
      }
      @if ((!isAuthLoading || isRouterPathUnauthorizedOrMaintenance()) && !userIsLoading()) {
        <router-outlet></router-outlet>
      }
    </div>
  }
  @if (router.url !== '/login') {
    <app-footer />
  }
</mat-sidenav-container>
<app-upload-progress-overlay />
